import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tabs',
  template: `
<div id="tabbar" class="container text-white text-left">
  <div class="row">
    <a
      *ngIf="Tab1Name && Tab1Link"
      class="tab p-3"
      [routerLink]="[Tab1Link]"
      routerLinkActive="active"
    >
      {{ Tab1Name }}
    </a>

    <a
      *ngIf="Tab2Name && Tab2Link"
      class="tab p-3"
      [routerLink]="[Tab2Link]"
      routerLinkActive="active"
    >
      {{ Tab2Name }}
    </a>
  </div>
</div>
`
})
export class TabsComponent {
  @Input() Tab1Name: string;
  @Input() Tab1Link: string;
  @Input() Tab2Name: string;
  @Input() Tab2Link: string;
}



// WEBPACK FOOTER //
// ./src/app/global/tabs.component.ts